import { useQuery } from '@tanstack/react-query';

import {
  useRequest,
  getMemberEmailNotificationSettingsKey,
} from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type {
  TeamMemberEmailNotificationSettingsData,
  MemberEmailNotificationSettingsKey,
} from './types';

export const useGetMemberEmailNotificationSettings: QueryFunction<
  TeamMemberEmailNotificationSettingsData[],
  [],
  MemberEmailNotificationSettingsKey
> = ({ requestOptions, queryOptions } = {}) => {
  const queryKey = getMemberEmailNotificationSettingsKey();
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/member_email_notification_settings`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
